import { render } from "./ScrollUp.vue?vue&type=template&id=a298d3b6"
import script from "./ScrollUp.vue?vue&type=script&lang=js"
export * from "./ScrollUp.vue?vue&type=script&lang=js"

import "./ScrollUp.vue?vue&type=style&index=0&id=a298d3b6&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__